import { StaticImport } from 'next/dist/shared/lib/get-img-props';
import type { ComponentProps, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import PlusUpsell2026 from '../PlusUpsell2026/PlusUpsell2026';
import defaultHeaderImage from './images/plus-header.avif';

export const plusUpsellHeading = <FormattedMessage defaultMessage="Elevate your adventure" />;
export const plusUpsellPromoEligibleHeading = <FormattedMessage defaultMessage="Your first week’s on us" />;

type Props = {
  headerImageSrc?: StaticImport;
  heading?: ReactNode;
  promoEligibleHeading?: ReactNode;
} & Omit<ComponentProps<typeof PlusUpsell2026>, 'headerImageSrc' | 'heading' | 'promoEligibleHeading'>;

export default function GenericPlusUpsell({
  headerImageSrc = defaultHeaderImage,
  heading = plusUpsellHeading,
  promoEligibleHeading = plusUpsellPromoEligibleHeading,
  ...props
}: Props) {
  return <PlusUpsell2026 {...props} headerImageSrc={headerImageSrc} heading={heading} promoEligibleHeading={promoEligibleHeading} />;
}
